import React from 'react';

export const NotFoundPage = () => {
  return (
    <div>
      <h3>This page does not exist. Please contact system administrator.</h3>
    </div>
  );
};
